import React from 'react';

import icon from '@assets/img/icons/delegation-form.svg';
import pdfIcon from '@assets/img/icons/pdf.svg';
import { Button } from '@components/Button';
import { Layout } from '@components/Layout';
import { MembershipContainer } from '@components/settings/MembershipContainer';
import { strings as membershipFormStrings } from '@data/membershipForm';
import { useDelegation } from '@hooks/queries/useDelegation';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: membershipFormStrings.delegationForm,
    download: 'ダウンロード',
    fileName: '委任状.pdf',
    noForm: '委任状はアップロードされていません。',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    padding: '1rem 2rem',
    [theme.breakpoints.down('sm')]: {
      ...common.flexInline,
      justifyContent: 'center',
    },
  },
  download: {
    ...common.flexColumn,
    alignSelf: 'flex-start',
    alignItems: 'center',
  },
  button: {
    marginTop: '1rem',
    width: 200,
  },
  contactToChangeInformation: {
    ...common.middleText,
    ...common.textError,
    paddingTop: '1rem',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
}));

export const DelegationForm: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { data, isLoading } = useDelegation();

  const renderDownload = () => (
    <>
      <a href={data!.file!} target="_blank" rel="noreferrer">
        <img src={pdfIcon} alt="Delegation Form PDF Icon" height={44} width={44} />
      </a>
      <a href={data!.file!} target="_blank" rel="noreferrer">
        <Button text={strings.download} className={classes.button} color="primary" />
      </a>
    </>
  );

  return (
    <Layout
      loading={isLoading}
      title={strings.title}
      breadcrumbs={['/utilities/Dashboard', '/settings/Membership/DelegationForm']}
    >
      {() => (
        <MembershipContainer>
          <div className={classes.container}>
            <div className={classes.download}>{data!.file ? renderDownload() : strings.noForm}</div>
          </div>

          <div className={classes.contactToChangeInformation}>
            {membershipFormStrings.contactToChangeInformation}
          </div>
        </MembershipContainer>
      )}
    </Layout>
  );
};

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 4,
};
